module.exports = __webpack_public_path__ + "static/media/3_terveytta-ja-hyvinvointia.850414e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/3_terveytta-ja-hyvinvointia.svg
// module id = ./src/images/agendaIcons/3_terveytta-ja-hyvinvointia.svg
// module chunks = 1